import { configureStore } from '@reduxjs/toolkit';
import cartSlice from './cartStore';
import siteSlice from './siteStore';

export default configureStore({
  reducer: {
    cart: cartSlice,
    site: siteSlice,
  },
});
